<template>
  <div v-if="alertIsOpen" class="travel-order-alert">
    <button
      class="travel-order-alert__close btn--reset"
      type="button"
      @click="() => setAlertIsOpen(false)"
    >
      <Icon name="times" />
    </button>

    <div class="travel-order-alert__body">
      <Icon name="exclamation" extra-classes="icon--xl mx-auto color-negative" />

      <div class="color-text-dark font-size-sm font-weight-bold mt-3 mt-md-4">
        {{ i18n.travelOrderAlertTitle }}
      </div>

      <p
        class="color-text-dark font-size-xs font-weight-semibold lheight-wide capped-xs mt-3 mb-0 mx-auto"
        v-html="travelOrderAlertText"
      />

      <div class="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-center mt-3 mt-md-4">
        <button
          class="btn btn--secondary btn--lg"
          type="button"
          @click="() => setAlertIsOpen(false)"
        >
          Annuleer wijzigingen
        </button>

        <button
          class="btn btn--secondary btn--lg mt-3 mt-sm-0 ml-sm-3 ml-md-4"
          type="button"
          @click="() => setAlertIsOpen(false)"
        >
          Ga door met wijzigen
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Icon from '@/cart/components/Icon.vue';

export default {
  components: {
    Icon,
  },

  computed: {
    ...mapGetters([
      'alertIsOpen',
    ]),

    travelOrderAlertText() {
      return this.i18n.travelOrderAlertText
        .replace('%s', `<span class="color-primary">accommodatie hier</span>`)
        .trim();
    },
  },

  methods: {
    ...mapMutations([
      'setAlertIsOpen',
    ]),
  },
};
</script>
